/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { GetEmailDomainsListResponse } from './GetEmailDomainsListResponse.types.tsx';

const JSM_EMAIL_DOMAINS_LIST = 'JSM_EMAIL_DOMAINS_LIST';

export const jsmEmailDomainsListResource: RouteResource<GetEmailDomainsListResponse> =
	createResource<GetEmailDomainsListResponse>({
		type: JSM_EMAIL_DOMAINS_LIST,
		getKey: () => 'email-domains-list',
		isBrowserOnly: true,
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-jsm-email-domains-list", jiraSpaEntry: "async-resource-jsm-email-domains-list" */ './emailDomainsListFetch.tsx'
			),
	});
